module.exports = {
  mobilePivot: 992
};